import httpClient from '../http'

export default {
  get() {
    return httpClient.get(`/api/notice`)
  },
}
